import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeLevelOptions } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/teacher-courses/TeacherCoursesAction";
import { useSectionsAndCoursesUIContext } from "../SectionsAndCoursesUIContext";

const prepareFilter = (queryParams, values) => {
  let { gradeLevel, sectionId, courseId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { gradeLevel, sectionId, courseId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SectionAndCoursesFilter() {
  // Section And Courses UI Context
  const sectionAndCoursesUIContext = useSectionsAndCoursesUIContext();
  const sectionAndCoursesUIProps = useMemo(() => {
    return {
      setQueryParams: sectionAndCoursesUIContext.setQueryParams,
      queryParams: sectionAndCoursesUIContext.queryParams,
    };
  }, [sectionAndCoursesUIContext]);

  const dispatch = useDispatch();
  const { sections, courses } = useSelector(
    (state) => ({
      sections: state.teacherCourses.sections,
      courses: state.teacherCourses.courses
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getList());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(sectionAndCoursesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, sectionAndCoursesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      sectionAndCoursesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);
  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions);
  const courseOptions = FilterOptions.concat(courses);

  return (
    <Formik
      initialValues={{}}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  dispatch(actions.getSections(e.value));
                  setFieldValue("gradeLevel", e.value);
                  setFieldValue("sectionId", undefined);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}